import React, { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import './Thousand.css'; 

const Thousandfour = ({ defdata, onChange }) => {
  const [month, setMonth] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (defdata) {
      const datePart = defdata?.split(' ')[0]; 
      const [year, month] = datePart?.split('-');
      setMonth(dayjs(`${year}-${month}`));
      setIsReady(true);
    }
  }, [defdata]);

  const handleMonthChange = (value) => {
    if (!value) return;

    const today = new Date();
    const day = today.getDate() > 10 ? today.getDate() : `0${today.getDate()}`;
    const dateStr = `${value.format('YYYY-MM')}-${day} 00:00:00.000`;

    setMonth(value);
    onChange?.(dateStr);
  };

  return (
    <>
      {isReady ? (
        <div className='form-group' style={{ paddingBottom: '10px' }}>
          <label htmlFor='monthyear' style={{ fontWeight: '600', fontSize: '18px' }}>Select Month</label>
          <br/>
          <DatePicker
            picker="month"
            value={month}
            onChange={handleMonthChange}
            format="MMMM YYYY"
            style={{ width: "100%" }}
            allowClear={false}
            getPopupContainer={(trigger) => trigger.parentNode}
          />
        </div>
      ) : (
        'Loading...'
      )}
    </>
  );
};

export default Thousandfour;
